// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section[data-v-0256ec5b]{padding:.5rem 1rem 1rem 1rem;height:auto;overflow:hidden;border-bottom:1px solid #d3d3d3}.is-pulled-right[data-v-0256ec5b]{align-items:right}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
